import { CircularProgress } from '@mui/material';
import React, { useEffect, useRef } from 'react';

interface LoadingMaskProps {
  isLoading: boolean | null;
  verticalAlignment?: 'flex-start' | 'center' | 'flex-end';
}

const LoadingMask: React.FC<LoadingMaskProps> = ({
  isLoading,
  verticalAlignment = 'flex-start',
}) => {
  const maskRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (isLoading === null) {
      document.getElementById('chat-input')?.blur();
    }
  }, [isLoading]);

  if (isLoading === false) {
    return null;
  }

  return (
    <div
      id="loading-mask"
      ref={maskRef}
      style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        zIndex: 5,
        background: 'white',
        opacity: 0.8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: verticalAlignment,
      }}
    >
      {isLoading === true && <CircularProgress />} {/* Show spinner only if `isLoading` is true */}
    </div>
  );
};

export default LoadingMask;
